import type { ReactNode } from "react"

import { cx } from "../lib/cx"
import { Button } from "./button"
import styles from "./empty-state.module.css"

/**
 * Пустое состояние.
 *
 * ОДНО ДЕЙСТВИЕ ИЛИ НИ ОДНОГО — третьего в макете нет, и это не про красоту.
 * Пустой экран встречает человека в его первый день: два равных предложения на нём
 * превращаются в выбор, которого он сделать не может. Поэтому действие ровно одно —
 * следующий шаг.
 *
 * А ЕСЛИ ПРАВА НА ЭТО ДЕЙСТВИЕ НЕТ — кнопки нет ВОВСЕ, и текст другой. Администратор,
 * которому нельзя заводить мастеров, не должен читать «добавьте мастера»: он увидит
 * «салон ещё настраивается» и не пойдёт искать кнопку, которой у него не будет.
 * Это единственное место в библиотеке, где отсутствие права прячет элемент, а не гасит
 * его: гасить нечего — предложение целиком адресовано не ему.
 */
export function EmptyState(props: {
  readonly title: string
  readonly text: string
  readonly action?:
    | {
        readonly label: string
        readonly onClick: () => void
      }
    | undefined
  readonly className?: string | undefined
}): ReactNode {
  const hasAction = props.action !== undefined

  return (
    <div className={cx(styles.empty, hasAction ? undefined : styles.quiet, props.className)}>
      <p className={styles.title}>{props.title}</p>
      <p className={styles.text}>{props.text}</p>
      {props.action === undefined ? null : (
        <Button variant="primary" className={styles.action} onClick={props.action.onClick}>
          {props.action.label}
        </Button>
      )}
    </div>
  )
}
